import { ILinkedServiceTypeMetadata, IDynamicLinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { azurePostgreSqlMetadata, getControlsByVersion } from './azure-postgre-sql-metadata';
import { driverVersions } from '../consts/tabular-consts';
import { AzureHorizonDBCopySource } from 'app/model/pipeline/copysource/azure-horizon-db.copysource';
import { AzureHorizonDBSink } from 'app/model/pipeline/copysink/azure-horizon-db.copysink';

/**
 * Azure HorizonDB is PostgreSQL wire-compatible, so its connector reuses the exact same connection
 * experience, authentication, private-endpoint and serialization behavior as Azure Database for
 * PostgreSQL. This metadata delegates to the PostgreSQL linked-service metadata and only overrides
 * the connector identity and the native copy source/sink types so that HorizonDB surfaces as its
 * own first-class connector in the copy activity and copy job wizards.
 *
 * Registration is gated by the `enableAzureHorizonDb` flag (see connector-metadata-initialization),
 * so the native connector is only exposed when the HorizonDB backend is ready.
 */
export const azureHorizonDbMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const base = await azurePostgreSqlMetadata(injector);
    const metadata: ILinkedServiceTypeMetadata = {
        ...base,
        type: adfModelTypeMap.azureHorizonDb.linkedServiceType,
        displayName: stringResources.AzureHorizonDB_DisplayText,
        icon: {
            className: 'svg-i-100x100-azure_horizonDB'
        },
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: adfModelTypeMap.azureHorizonDb.linkedServiceType as ResourceKind
        },
        // HorizonDB is newly introduced and has no driver-version concept, so the version selector
        // is removed and the connection form uses the modern (v2) driver controls directly.
        controls: getControlsByVersion(driverVersions.v2),
        copySourceTypes: [Metamodel.modelFor(AzureHorizonDBCopySource).name],
        copySinkTypes: [Metamodel.modelFor(AzureHorizonDBSink).name]
    };
    return metadata;
};
